import client from './client'

export interface AlumniProfileItem {
  id: string
  user_id: string
  full_name: string
  username: string
  avatar_url: string
  company: string
  job_title: string
  industry: string
  graduation_year: number
  degree_course: string
  previous_college: string
  college_id: string
  bio: string
  skills: string[]
  expertise: string[]
  experience: {
    role: string
    company: string
    duration: string
    description: string
  }[]
  is_verified: number
  is_demo: number
  is_following?: boolean
  questions_answered_count?: number
  helpful_votes_count?: number
  recent_answers?: {
    id: string
    content: string
    helpful_count: number
    created_at: string
    question_id: string
    question_title: string
    question_category: string
  }[]
}

export interface AlumniFilterParams {
  q?: string
  college?: string
  course?: string
  year?: string | number
  company?: string
  industry?: string
  expertise?: string
  skill?: string
  verified_only?: boolean | string
  page?: number
  limit?: number
}

export const alumniApi = {
  getAll: (params?: AlumniFilterParams) =>
    client.get<{ success: boolean; data: AlumniProfileItem[]; meta?: { count: number; page: number } }>('/alumni', { params }),

  getById: (id: string) =>
    client.get<{ success: boolean; data: AlumniProfileItem }>(`/alumni/${encodeURIComponent(id)}`),

  getAnswers: (id: string) =>
    client.get<{ success: boolean; data: any[] }>(`/alumni/${encodeURIComponent(id)}/answers`),

  getQuestions: (id: string) =>
    client.get<{ success: boolean; data: any[] }>(`/alumni/${encodeURIComponent(id)}/questions`),
}
